import styled from 'styled-components';

export const Container = styled.div``;

export const AccordionHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const AccordionHeaderLeft = styled.span`
  text-align: left;
`;

export const AccordionHeaderRight = styled.span`
  text-align: right;
  margin-right: 10px;
  color: var(--primary);
`;
